import React from 'react';
export var SelectContext = React.createContext({
    selectedOptionValues: [],
    multiple: false,
    custom: false,
    isVisibleOptions: false,
    setIsVisibleOptions: function () { return false; },
    setSelectedOptionValues: function () { return []; },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9jb21wb25lbnRzL3NlbGVjdC9jb250ZXh0L2luZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEtBQUssTUFBTSxPQUFPLENBQUE7QUFhekIsTUFBTSxDQUFDLElBQU0sYUFBYSxHQUFHLEtBQUssQ0FBQyxhQUFhLENBQVc7SUFDekQsb0JBQW9CLEVBQUUsRUFBRTtJQUN4QixRQUFRLEVBQUUsS0FBSztJQUNmLE1BQU0sRUFBRSxLQUFLO0lBQ2IsZ0JBQWdCLEVBQUUsS0FBSztJQUN2QixtQkFBbUIsRUFBRSxjQUFNLE9BQUEsS0FBSyxFQUFMLENBQUs7SUFDaEMsdUJBQXVCLEVBQUUsY0FBTSxPQUFBLEVBQUUsRUFBRixDQUFFO0NBQ2xDLENBQUMsQ0FBQSJ9